// extracted by mini-css-extract-plugin
export default {"info_box":"index_info_box_2uS-O clearfix","comment":"index_comment_eU2fl","pic":"index_pic_AlOM5","v_logo":"index_v_logo_4AN9G","text":"index_text_qT9CQ","time":"index_time_8Uoo7"};